const enumFormatos = [
  {},
  {
    title: 'Padrão'
  },
  {
    title: 'Galeria'
  },
  {
    icon: 'el-icon-headset',
    title: 'Áudio'
  },
  {
    icon: 'el-icon-caret-right',
    title: 'Vídeo'
  }
]

export { enumFormatos }
